
import { deepCopy } from "@/utils/utils";
const state = {
  wineCellarAddress: '',
  wineCellarApplyParams: {

  }
}
const mutations = {
  SET_WINE_CELLAR_ADDRESS (state, value) {
    state.wineCellarAddress = value
  },
  SET_WINE_CELLAR_APPLY_PARAME (state, value) {
    state.wineCellarApplyParams = deepCopy(value)
  }
}
const actions = {
  setWineCellarAddress ({ commit }, value) {
    commit('SET_WINE_CELLAR_ADDRESS', value)
  },
  setWineCellarApplyParams ({ commit }, value) {
    commit('SET_WINE_CELLAR_APPLY_PARAME', value)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
